import { render } from "./UserView.vue?vue&type=template&id=5ccdbad9"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"

import "./UserView.vue?vue&type=style&index=0&id=5ccdbad9&lang=css"

import exportComponent from "E:\\XZN2\\trunk\\soft\\server\\userweb\\user_client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__